import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { UPDATE_USER, VALIDATE_USER, GET_USER_DETAILS } from './constants';

const initialState = {
  uuid: '',
  userPermissions: [],
  hasPermissions: false,
  permissions: [],
  preference: {},
  admin: {},
  privileges: [],
  allPermission: false,
  permissionCode: [],
  permissionSubCode: [],
  provider: {},
  corporates: [],
};

export const userReducer = createReducer(initialState, {
  [UPDATE_USER]: (state, action) => {
    return {
      ...state,
      ...action.payload,
      hasPermissions: state.hasPermissions || !!action.payload.permissions,
    };
  },

  [`${VALIDATE_USER}_SUCCESS`]: (state, action) => {
    return action.payload;
  },

  [`${GET_USER_DETAILS}_SUCCESS`]: (state, action) => {
    return action.payload;
  },
});
